import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard, SuperOpsGuard } from './shared';

export const routes: Routes = [
  {
    canActivate: [AuthGuard, SuperOpsGuard],
    loadChildren: () => import('./layout/layout.module').then((m) => m.LayoutModule),
    path: '',
  },
  {
    canActivate: [AuthGuard],
    loadChildren: () => import('./superops-required/superops-required.module').then((m) => m.SuperOpsRequiredModule),
    path: 'superops-required',
  },
  {
    loadChildren: () => import('./layout/sso/sso.module').then((m) => m.SsoModule),
    path: 'sso',
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
})
export class AppRoutingModule {}
